<div echarts [options]="commonChartOptions" [merge]="chartData()" [style.height.px]="containerHeight()"></div>
